import React from "react";
import styles from "./fillspace.module.css";
import classNames from "classnames";

function FillSpace({
  children,
  vh,
  vw,
}: React.PropsWithChildren<{
  vw?: boolean;
  vh?: boolean;
}>) {
  return (
    <div
      className={classNames(styles.fillspace, {
        [styles.fillspaceVw]: vw,
        [styles.fillspaceVh]: vh,
      })}>
      {children}
    </div>
  );
}

export default FillSpace;
